import * as types from '../types/index'

export const userAuthReducer = (state = { loading: false }, action) => {
	switch (action.type) {
		case types.USER_AUTH_REQUEST:
			return { ...state, loading: true }
		case types.USER_AUTH_SUCCESS:
			return { loading: false, userDetail: action.payload }
		case types.USER_AUTH_FAIL:
			return { loading: false, error: action.payload }
		case types.USER_AUTH_LOGOUT:
			return {}
		default:
			return state
	}
}

export const userRegisterReducer = (state = {}, action) => {
	switch (action.type) {
		case types.USER_REGISTER_REQUEST:
			return { loading: true }
		case types.USER_REGISTER_SUCCESS:
			return { loading: false, userDetail: action.payload }
		case types.USER_REGISTER_FAIL:
			return { loading: false, error: action.payload }
		case types.USER_REGISTER_RESET:
			return {}
		default:
			return state
	}
}

export const userVerifyEmailReducer = (state = {}, action) => {
	switch (action.type) {
		case types.USER_VERIFY_EMAIL_REQUEST:
			return { loading: true }
		case types.USER_VERIFY_EMAIL_SUCCESS:
			return { loading: false, verify_email: action.payload, success: true }
		case types.USER_VERIFY_EMAIL_FAIL:
			return { loading: false, error: action.payload }
		case types.USER_VERIFY_EMAIL_RESET:
			return {}
		default:
			return state
	}
}

export const getUserProfileReducer = (state = { userProfile: {} }, action) => {
	switch (action.type) {
		case types.GET_USER_PROFILE_REQUEST:
			return { ...state, loading: true, userProfile: {} }
		case types.GET_USER_PROFILE_SUCCESS:
			return { loading: false, userProfile: action.payload }
		case types.GET_USER_PROFILE_FAIL:
			return { loading: false, error: action.payload, userProfile: {} }
		case types.GET_USER_PROFILE_RESET:
			return {}
		default:
			return state
	}
}

export const userUpdateProfileReducer = (state = {}, action) => {
	switch (action.type) {
		case types.UPDATE_USER_PROFILE_REQUEST:
			return { loading: true }
		case types.UPDATE_USER_PROFILE_SUCCESS:
			return { loading: false, success: true, userDetail: action.payload }
		case types.UPDATE_USER_PROFILE_FAIL:
			return { loading: false, error: action.payload }
		case types.UPDATE_USER_PROFILE_RESET:
			return {}
		default:
			return state
	}
}

export const getAllUsersReducer = (state = {}, action) => {
	switch (action.type) {
		case types.GET_ALL_USERS_REQUEST:
			return { loading: true }
		case types.GET_ALL_USERS_SUCCESS:
			return { loading: false, users: action.payload }
		case types.GET_ALL_USERS_FAIL:
			return { loading: false, error: action.payload }
		case types.GET_ALL_USERS_RESET:
			return {}
		default:
			return state
	}
}

export const getUserDetailsReducer = (state = { userDetails: {} }, action) => {
	switch (action.type) {
		case types.GET_USER_DETAILS_REQUEST:
			return { ...state, loading: true, userDetails: {} }
		case types.GET_USER_DETAILS_SUCCESS:
			return { loading: false, userDetails: action.payload }
		case types.GET_USER_DETAILS_FAIL:
			return { loading: false, error: action.payload, userDetails: {} }
		case types.GET_USER_DETAILS_RESET:
			return {}
		default:
			return state
	}
}
